const contactAccountPartyDataModalTypes = {
    CREATE_CREDITOR: 'CREATE_CREDITOR',
    CREATE_DEBTOR: 'CREATE_DEBTOR',
    EDIT_CREDITOR: 'EDIT_CREDITOR',
    EDIT_DEBTOR: 'EDIT_DEBTOR',
};

export default contactAccountPartyDataModalTypes;
